export enum BUILD_ENV {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}
